var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditnew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2935_1246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 2.5H4.16585C3.72391 2.5 3.30007 2.67556 2.98757 2.98806C2.67507 3.30056 2.49951 3.7244 2.49951 4.16634V15.8307C2.49951 16.2727 2.67507 16.6965 2.98757 17.009C3.30007 17.3215 3.72391 17.4971 4.16585 17.4971H15.8302C16.2722 17.4971 16.696 17.3215 17.0085 17.009C17.321 16.6965 17.4966 16.2727 17.4966 15.8307V9.99854",
    stroke: "#E17100",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3095 2.18563C15.641 1.85418 16.0905 1.66797 16.5593 1.66797C17.028 1.66797 17.4776 1.85418 17.809 2.18563C18.1405 2.51709 18.3267 2.96664 18.3267 3.43539C18.3267 3.90414 18.1405 4.35369 17.809 4.68515L10.2997 12.1953C10.1018 12.393 9.85743 12.5377 9.58898 12.6161L7.19528 13.316C7.12358 13.3369 7.04759 13.3381 6.97524 13.3196C6.9029 13.3011 6.83687 13.2634 6.78406 13.2106C6.73126 13.1578 6.69362 13.0918 6.67508 13.0194C6.65655 12.9471 6.6578 12.8711 6.67871 12.7994L7.37858 10.4057C7.45733 10.1375 7.60231 9.89335 7.80016 9.69584L15.3095 2.18563Z",
    stroke: "#E17100",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2935_1246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9961,
    height: 19.9961,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditnew);
export default __webpack_public_path__ + "static/media/editnew.c960c994e3bdba14ad9be42483deaa3c.svg";
export { ForwardRef as ReactComponent };